import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CaseStudyVideoGallery from "../CaseStudyVideoGallery";

const CASE_STUDIES_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_case_study_videos";

function CaseStudiesSection() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${CASE_STUDIES_API}?page=1&limit=2`)
      .then((response) => {
        if (!response.ok) throw new Error("Unable to load case studies");
        return response.json();
      })
      .then((json) => setVideos(Array.isArray(json?.data) ? json.data.slice(0, 2) : []))
      .catch(() => setVideos([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div id="case-studies">
      <section className="case-study-section bg-white">
        <div className="divider"></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8">
              <div className="section-heading text-center">
                <div className="sub-title justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Case Studies
                </div>
                <h2>Explore Case Studies</h2>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5"><div className="spinner-border text-secondary" role="status"><span className="visually-hidden">Loading...</span></div></div>
          ) : videos.length > 0 ? (
            <CaseStudyVideoGallery videos={videos} />
          ) : (
            <p className="text-center py-4">No case study videos are available yet.</p>
          )}

          <div className="text-center mt-5">
            <Link to="/case-studies" className="btn btn-primary">
              <span>View All Videos <i className="ti ti-arrow-up-right"></i></span>
              <span>View All Videos <i className="ti ti-arrow-up-right"></i></span>
            </Link>
          </div>
        </div>
        <div className="divider"></div>
      </section>
    </div>
  );
}

export default CaseStudiesSection;
